import * as React from 'react';
const CsvTable = ({ data }) => (React.createElement("table", null,
    React.createElement("tbody", null, data.map((line, rowIndex) => (React.createElement("tr", { key: rowIndex.toString() }, line.map((item, index) => (React.createElement("td", { key: `${rowIndex.toString()}${index.toString()}`, style: { borderStyle: 'dotted', borderWidth: 'thin', padding: '0.5rem' } }, item)))))))));
export default CsvTable;
